<template>	
	<property name="Поселение" v-if="doc.settlement" :value="doc.settlement">
	</property>
</template>
<script>
	import Property from '@/components/common/Property'
	export default {
		props: ['doc'],
		components: {			
			Property
		},
	}
</script>
